<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <!-- 头部搜索框 start  -->
      <SearchBlock
        ref="searchBlock"
        v-model="searchBlockData"
        :can-operate-data="canOperateData"
        :class-list-search="true"
        :class-list-delete="true"
        @getSearchValue="handleGetSearchValue"
      ></SearchBlock>
    </div>
    <!-- 课班列表表格部分 start  -->
    <div class="table">
      <Table
        ref="selection"
        border
        :max-height="tableHeight"
        :columns="classColumn"
        :data="classData"
        :loading="loadingCourse"
      >
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="relClassroomName" slot-scope="{ row }">
          <TablePoptip :content="row.relClassroomName"> </TablePoptip>
        </template>

        <template slot="teacherDesc"> -- </template>
        <template slot="courseState" slot-scope="{ row }">
          {{ row.status === 0 ? '已删除' : '--' }}
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="action-block">
            <span class="click-btn-430" @click="handleToDetail(row)">详情</span>
            <span
              class="click-btn-430"
              @click="handleToAttendancePage(row)"
            >考勤</span>
            <!-- <span class="click-btn-430 error" @click="handleStopClass">停课</span> (v2.0这期不做))-->
          </div>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <!-- 课班列表表格部分 end  -->
  </div>
</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot
} from '@/assets/js/resetTableStyle';
import { mapState, mapGetters, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import {
  changeDictionaries,
  courseClassList
} from '@/utils/dictionary.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'CourseSchedulCenterDivideClassManageDeleteClassList',
  components: {
    SearchBlock // 搜索框组件
  },
  mixins: [mixinTableHeight],
  // 当是要去考勤详情页面或者是要去考勤记录页面的时候，就保留当前页面操作
  beforeRouteLeave(to, from, next) {
    // if (to.name === 'courseSchedulCenter_divideClassManage_deleteClassList_attendanceRecord' || to.name === 'courseSchedulCenter_divideClassManage_deleteClassList_detail') {
    //   this.SET_CACHEROUTE(['CourseSchedulCenterDivideClassManageDeleteClassList']);
    // } else {
    //   this.SET_CACHEROUTE([]);
    // }
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassManageDeleteClassList');
    next();
  },
  data() {
    return {
      // 课班列表的表头
      classColumn: [
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6, { fixed: 'left' }),
        slot('学校', 'schoolName', tableColumnsWidth.type6, { fixed: 'left' }),
        key('学期', 'termName', tableColumnsWidth.type4),
        key('课程类别', 'classType', tableColumnsWidth.type2, {
          render: (h, params) => {
            return h('div', [
              changeDictionaries(courseClassList)[params.row.classType]
            ]);
          },
          align: 'center'
        }),
        key('课程分类', 'courseTypeName', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('商品ID', 'relClassroomId', tableColumnsWidth.type4),
        slot('课程商品名称', 'relClassroomName', tableColumnsWidth.type6),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        key('学生数', 'registeredNumbers', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('上课时间', 'timeDesc', tableColumnsWidth.type4, {
          render: (h, params) => {
            return h(
              'div',
              {
                class: {
                  'time-line-courselist': true
                }
              },
              [params.row.timeDesc]
            );
          }
        }),
        key('开课日期', 'classDateBegin', tableColumnsWidth.type3, {
          render: (h, params) => {
            return h('div', [params.row.classDateBegin.split(' ')[0]]);
          }
        }),

        key('总课次', 'classroomTotal', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('上课场地', 'placeName', tableColumnsWidth.type5),
        slot('负责教师', 'teacherDesc', tableColumnsWidth.type2),
        slot('状态', 'courseState', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('删除时间', 'operateTime', tableColumnsWidth.type3),
        slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
      ],
      classData: [], // 课班列表数据
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 课班列表分页信息
      searchData: {}, // 从搜索框组件拿到的搜索入参
      portOrg: -1, // 处于哪个端
      loadingCourse: false, // 是否在请求课班列表数据
      searchBlockData: {}
    };
  },
  activated() {
    this.getCourseList();
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity', 'routeTitle']),
    // 是否可以操作数据(分端权限)
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if (this.portOrg === 0 || this.portOrg === 2) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.getCourseList();
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE', 'PUSH_CACHEROUTE']),
    // 获取搜索组件传来的搜索入参
    handleGetSearchValue(searchData) {
      console.log('searchData', searchData);
      this.pageInfo.pageNum = 1;
      this.searchData = { ...searchData };
      this.searchData.classType === '0'
        ? (this.searchData.classType = null)
        : '';
      this.getCourseList();
    },
    // 点击分页页码
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getCourseList();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getCourseList();
    },
    // 点击跳转到详情页面
    handleToDetail(row) {
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_list_detail',
      //   query: { classroomId: row.classroomId }
      // });
      // window.open(href);
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_deleteClassList_detail',
        query: { classroomId: row.classroomId }
      });
    },
    // 点击跳转到考勤页面
    handleToAttendancePage(row) {
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_deleteClassList_attendanceRecord',
      //   query: { classroomId: row.classroomId }
      // });
      // window.open(href);
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_deleteClassList_attendanceRecord',
        query: { classroomId: row.classroomId, operateTime: row.operateTime }
      });
    },
    // 获取列表信息(到时候替换成删除列表接口========)
    async getCourseList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        classroomStatus: 0
      };
      const paramsData = Object.assign(this.searchData, params);
      try {
        this.loadingCourse = true;
        const res = await courseSchedulCenter.getCourseClassList(paramsData);
        if (res.status === 200) {
          this.classData = res.message.list;
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingCourse = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin-top: 32px;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.table {
  padding-top: 16px;
}
.action-block {
  // span {
  //   color: #488ffa;
  // }
  // .error {
  //   color: rgb(255, 92, 92);
  // }
  span + span {
    margin-left: 8px;
  }
}
.ex-select {
  display: flex;
  text-align: center;
  justify-content: center;
  margin-bottom: 20px;
}
.price-btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 24px;
  }
}
.item-box-430 {
  .ex-btn {
    text-align: right;
    margin: 20px 0;
  }
}
</style>
<style lang="scss">
.time-line-courselist {
  line-height: 24px;
  padding: 8px 0;
}
</style>
